import React, { useState } from "react";

import FormField from "../../common/FormField";

import {
  PROJECT_STATUS_OPTIONS,
} from "../../../constants/admin/project/projectConstants";

import {
  validateProjectForm,
} from "../../../utils/admin/projectValidation";

import {
  getProjectImage,
} from "../../../utils/admin/projectUtils";

const ProjectForm = ({
  formData,
  handleChange,
  handleImageChange,
  handleRemoveImage,
  handleSubmit,
  initialData,
  imageFiles,
  onClose,
  isSubmitting,
}) => {
  const [errors, setErrors] = useState({});

  const onSubmitForm = async (e) => {
    e.preventDefault();
    const validationErrors = validateProjectForm(
      formData,
      imageFiles,
      initialData
    );

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      return;
    }

    await handleSubmit();
  };

  return (
    <div className="bg-gray-100 dark:bg-gray-800 p-4 rounded">
      <h2 className="text-xl font-semibold mb-4">
        {initialData
          ? "Cập nhật dự án"
          : "Thêm dự án mới"}
      </h2>

      <form
        onSubmit={onSubmitForm}
        className="space-y-4"
      >
        <FormField
          label="Tên dự án"
          required
          error={errors.name}
        >
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          />
        </FormField>

        <FormField
          label="Chủ đầu tư"
          required
          error={errors.developer}
        >
          <input
            type="text"
            name="developer"
            value={formData.developer}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          />
        </FormField>

        <FormField
          label="Địa chỉ"
          required
          error={errors.location}
        >
          <input
            type="text"
            name="location"
            value={formData.location}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          />
        </FormField>

        <FormField
          label="Trạng thái"
          required
          error={errors.status}
        >
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full border p-2 rounded"
          >
            {PROJECT_STATUS_OPTIONS.map(
              (option) => (
                <option
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </option>
              )
            )}
          </select>
        </FormField>

        <FormField
          label="Link dự án"
          error={errors.url}
        >
          <input
            type="text"
            name="url"
            value={formData.url}
            onChange={handleChange}
            placeholder="https://example.com/project"
            className="w-full border p-2 rounded"
          />
        </FormField>

        <FormField
          label="Ảnh đại diện"
          error={errors.imagePreview}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
          />

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-3">
            {imageFiles.map((file, index) => (
              <div
                key={index}
                className="relative"
              >
                <img
                  src={URL.createObjectURL(file)}
                  alt={`preview-${index}`}
                  className="h-32 w-full object-cover rounded border"
                />

                <button
                  type="button"
                  onClick={() =>
                    handleRemoveImage(index)
                  }
                  className="absolute top-1 right-1 bg-red-600 text-white px-2 py-1 text-xs rounded"
                >
                  ✕
                </button>
              </div>
            ))}

            {!imageFiles.length &&
              Array.isArray(formData.image) &&
              formData.image.map((img, index) => (
                <img
                  key={index}
                  src={getProjectImage([img])}
                  alt={`project-${index}`}
                  className="h-32 w-full object-cover rounded border"
                />
              ))}
          </div>
        </FormField>

        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded"
          >
            Hủy
          </button>

          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
          >
            {isSubmitting
              ? "Đang xử lý..."
              : initialData
              ? "Cập nhật"
              : "Thêm mới"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProjectForm;